import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production'

import common from './modules/common';

export default new Vuex.Store({
	modules: {
		common,
	},
	strict: debug,
})


// WEBPACK FOOTER //
// ./src/store/index.js